import { APITestCategory, getCurrentUserQuery, getDevicesQuery, UserType } from '~src/generated/portal/graphql';
import { DeviceStatus } from '~/src/generated/portal/graphql';

type DeviceFromQuery = getDevicesQuery['devices'][0];

type CurrentUser = getCurrentUserQuery['currentUser'];

export const isPartnerLegalNameIncomplete = (user: CurrentUser | null | undefined): boolean => {
  if (!user || user.userType !== UserType.Partner) {
    return false;
  }
  return !user.firstName?.trim() || !user.lastName?.trim();
};

export const deviceRunningOtherTest = (testId: string, selectedDevice?: DeviceFromQuery) => {
  if (selectedDevice?.underTest === true && selectedDevice.testStatus?.test?.id != testId) return true;
  return false;
};

export const deviceNotConnected = (selectedDevice?: DeviceFromQuery) => {
  switch (selectedDevice?.status) {
    case DeviceStatus.Not_Connected_Reserved_By_Another:
    case DeviceStatus.Not_Connected_Reserved_By_You:
    case DeviceStatus.Not_Connected_Unreserved:
      return true;
    default:
      return false;
  }
};

export const categoryName = (category: APITestCategory | undefined | null) => {
  switch (category) {
    case APITestCategory.Key_Rotation:
      return 'Partner Key Rotation';
    case APITestCategory.Supplemental_Data:
      return 'Supplemental Data';
    default:
      return category;
  }
};

export const pathIsPublic = (path: string) => {
  const publicPaths = [
    'loggedOut',
    'loginError',
    'callback',
    'sign-in',
    'mfa',
    'sign-up',
    'change-password',
    'setup-mfa',
    'forgot-password',
    'request-access',
  ];

  return publicPaths.indexOf(path) > -1;
};

export const arraysEqualUnordered = <T>(arr1: T[], arr2: T[]): boolean => {
  return (
    arr1.length === arr2.length &&
    arr1.every((element) => arr2.includes(element)) &&
    arr2.every((element) => arr1.includes(element))
  );
};

export const getSetsPath = (partnerId: string, projectId: string, setId: string) =>
  `/app/partner/${partnerId}/adk/projects/${projectId}/sets/${setId}${window.location.search}`;

export const paramsToStr = <T extends object>(obj: T): string => {
  return Object.entries(obj)
    .map((el) => el.join('='))
    .join('&');
};
